import { FC } from "react";
import { useFormikContext } from "formik";
import { Button, styled } from "@mui/material";
import useLocales from "../../hooks/useLocales";
import { params } from "../../utils";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  border: "1px solid #1976d2",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

interface IClearButton {
  onSubmit: Function;
  defaultFilter?: any;
}

const ClearButton: FC<IClearButton> = ({ onSubmit, defaultFilter }) => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();

  function clickHandler() {
    formik.resetForm();
    onSubmit((prev: any) => ({
      ...prev,
      params: { ...params, filter: defaultFilter ? defaultFilter : {} },
    }));
  }

  return (
    <BootstrapButton
      type="button"
      className="btn"
      onClick={clickHandler}
      style={{ minWidth: "200px" }}
    >
      {translate("actions.clear")}
    </BootstrapButton>
  );
};
export default ClearButton;
